// extracted by mini-css-extract-plugin
module.exports = {"container":"ApiOpenToken__container___l39q_","left":"ApiOpenToken__left___3A1Ud","label":"ApiOpenToken__label___36kaV","scopes":"ApiOpenToken__scopes___xLzSV"};